import { useState } from "react"
import { Box } from "@material-ui/core"
import { Rating } from "@material-ui/lab"
import NCTable from "../../shared/table/NCTable"
import NCText from "../../shared/NCText"
import { useGetDriverReviews } from "../../services/queries"
import { formatDate } from "../../libs/utils"
import { useTranslation } from "react-i18next"

const DriverRatingsList = ({ driverId }) => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(5)

  const { data, isLoading } = useGetDriverReviews(driverId, page, pageSize, {
    enabled: !!driverId
  })

  const { next, previous, total_pages, results } = data?.data?.data || {}

  const onNext = () => {
    setPage(prev => (next ? prev + 1 : prev))
  }
  const onPrev = () => {
    setPage(prev => (previous ? prev - 1 : prev))
  }

  const columns = [
    {
      Header: t("drivers.rating"),
      id: "driver_rating",
      accessor: cell => cell?.driver_rating,
      Cell: ({ value }) => (
        <Box display="flex" alignItems="center" style={{ gap: 6 }}>
          <Rating
            value={value || 0}
            precision={0.5}
            readOnly
            size="small"
          />
          <NCText style={{ fontSize: "13px", color: "#6B7280" }}>
            {value}
          </NCText>
        </Box>
      ),
      disableSortBy: true
    },
    {
      Header: t("drivers.client_name"),
      id: "client_name",
      accessor: cell => cell?.client_name || "-",
      disableSortBy: true
    },
    {
      Header: t("drivers.feedback"),
      id: "driver_feedback",
      accessor: cell => cell?.driver_feedback || "-",
      disableSortBy: true
    },
    {
      Header: t("drivers.trip_date"),
      id: "trip_pickup_time",
      accessor: cell => formatDate(cell?.trip_pickup_time),
      disableSortBy: true
    },
    {
      Header: t("drivers.reviewed_on"),
      id: "created",
      accessor: cell => formatDate(cell?.created),
      disableSortBy: true
    }
  ]

  if (!isLoading && (!results || results.length === 0)) {
    return (
      <NCText style={{ color: "#9CA3AF" }}>
        {t("drivers.no_ratings_yet")}
      </NCText>
    )
  }

  return (
    <NCTable
      columns={columns}
      page={page}
      onNext={onNext}
      onPrev={onPrev}
      pageCount={total_pages}
      gotoPage={setPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      data={results || []}
      overrideFooterCss={{
        position: "static",
        margin: 0
      }}
    />
  )
}

export default DriverRatingsList
